import { render, staticRenderFns } from "./ChunkedJsonRenderer.vue?vue&type=template&id=59cc4db2&scoped=true"
import script from "./ChunkedJsonRenderer.vue?vue&type=script&lang=js"
export * from "./ChunkedJsonRenderer.vue?vue&type=script&lang=js"
import style0 from "./ChunkedJsonRenderer.vue?vue&type=style&index=0&id=59cc4db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc4db2",
  null
  
)

export default component.exports